import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import ArticlePage from './components/ArticlePage';
import './App.css';

function App() {
  const [customCursor, setCustomCursor] = useState(false);
  const [cursorDesign, setCursorDesign] = useState(1);
  const [dancingLetters, setDancingLetters] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const createConfetti = () => {
      const confettiTypes = ['square', 'circle', 'triangle', 'star', 'rectangle', 'hexagon'];
      const confettiCount = 50;

      // Create confetti pieces
      for (let i = 0; i < confettiCount; i++) {
        const confetti = document.createElement('div');
        confetti.className = `confetti-piece ${confettiTypes[Math.floor(Math.random() * confettiTypes.length)]}`;
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.animationDuration = (Math.random() * 2 + 2) + 's';
        confetti.style.animationDelay = (Math.random() * 0.3) + 's';
        document.body.appendChild(confetti);

        setTimeout(() => confetti.remove(), 5000);
      }

      // Create party poppers
      const popperCount = 8;
      for (let i = 0; i < popperCount; i++) {
        const popper = document.createElement('div');
        popper.className = 'popper';
        popper.style.left = (Math.random() * 80 + 10) + '%';
        popper.style.animationDelay = (Math.random() * 0.2) + 's';
        document.body.appendChild(popper);

        setTimeout(() => popper.remove(), 2500);
      }
    };

    const handleKeyPress = (e) => {
      if (e.key === 'x' || e.key === 'X') {
        setCustomCursor(prev => {
          if (!prev) {
            // Randomly select a design from 1-6 when enabling
            setCursorDesign(Math.floor(Math.random() * 6) + 1);
          }
          return !prev;
        });
      } else if (e.key === 'y' || e.key === 'Y') {
        createConfetti();
      } else if (e.key === 'm' || e.key === 'M') {
        setDancingLetters(prev => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (customCursor) {
      document.body.classList.add('custom-cursor');

      const cursorDot = document.createElement('div');
      cursorDot.className = `cursor-dot design-${cursorDesign}`;
      document.body.appendChild(cursorDot);

      const cursorOutline = document.createElement('div');
      cursorOutline.className = 'cursor-outline';
      document.body.appendChild(cursorOutline);

      const moveCursor = (e) => {
        cursorDot.style.left = e.clientX + 'px';
        cursorDot.style.top = e.clientY + 'px';
        cursorOutline.style.left = e.clientX + 'px';
        cursorOutline.style.top = e.clientY + 'px';
      };

      document.addEventListener('mousemove', moveCursor);

      return () => {
        document.removeEventListener('mousemove', moveCursor);
        cursorDot.remove();
        cursorOutline.remove();
      };
    } else {
      document.body.classList.remove('custom-cursor');
    }
  }, [customCursor, cursorDesign]);

  useEffect(() => {
    document.body.classList.toggle('dancing-letters', dancingLetters);
  }, [dancingLetters]);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  return (
    <BrowserRouter>
      <div className="App">
        <Header darkMode={darkMode} setDarkMode={setDarkMode} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
